// REACT, ROUTER, REDUX
import React, { useEffect, useState } from "react";

// NPM INSTALLS

// INTERFACE
import { MessageBoxProps } from "../../interface/propTypesInterface";

export default function MessageBoxTool(props: MessageBoxProps) {
  const {
    windowPrompt,
    windowTitle,
    windowButtonA,
    windowButtonB,
    windowButtonClose,
    windowButtonCallback,
    tooltip,
    faIcon,
    buttonText,
  } = props;
  const elemID = "message-box-tool";
  // ::::: USESTATES ::::
  const [show, setshow] = useState(false);
  const [elem, setelem] = useState<HTMLElement | null>();

  // ::::: USEHOOKS :::::
  useEffect(() => {
    setelem(document.getElementById(elemID));
  }, []);
  useEffect(() => {
    if (show) {
      document.documentElement.style.overflow = "hidden";
      window.addEventListener("keydown", handleKeyPress);
    } else {
      document.documentElement.style.overflow = "scroll";
      window.removeEventListener("keydown", handleKeyPress);
    }
    return () => {
      document.documentElement.style.overflow = "scroll";
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [show]);

  // ::::: HANDLER FUNCTIONS :::::
  const getColor = (buttonColor: string): string => {
    switch (buttonColor) {
      case "ACCENT":
        return "accent-color";
      case "ERROR":
        return "error-color";
      default:
        return "";
    }
  };

  const handleKeyPress = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
      setshow(false);
    }
  };

  const handleClick = (bool: boolean) => {
    setshow(false);
    windowButtonCallback(bool);
  };

  return (
    <div className="message-box">
      <button
        onClick={() => setshow(true)}
        className="rectangular-button small translateY"
        data-for="tooltip-calculatorpage"
        data-tip={tooltip}
      >
        {faIcon}
        {buttonText && (
          <span style={{ marginLeft: ".5rem" }}>{buttonText}</span>
        )}
      </button>
      <aside
        className={show ? "popup visible center" : "popup center"}
        id={elemID}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {windowButtonClose && (
          <button
            className="close-button"
            style={{ position: "absolute", left: "1.5rem", top: "2rem" }}
            type="button"
            onClick={() => handleClick(windowButtonClose.bool)}
            tabIndex={show ? 0 : -1}
          ></button>
        )}
        <h4 style={{ marginBottom: "1rem" }}>{windowTitle}</h4>
        <p style={{ textAlign: "center", marginBottom: "1rem" }}>
          {windowPrompt}
        </p>
        <div
          className="message-box__buttons"
          style={{ display: "flex", width: "100%" }}
        >
          {windowButtonA && (
            <button
              className={`rectangular-button small ${getColor(
                windowButtonA.color
              )}`}
              type="button"
              onClick={() => handleClick(windowButtonA.bool)}
              style={
                windowButtonB
                  ? { width: "100%", backgroundSize: "60rem" }
                  : { width: "100%", backgroundSize: "100rem" }
              }
              tabIndex={show ? 0 : -1}
            >
              {windowButtonA.prompt}
            </button>
          )}
          {windowButtonB && (
            <button
              className={`rectangular-button small ${getColor(
                windowButtonB.color
              )}`}
              type="button"
              onClick={() => handleClick(windowButtonB.bool)}
              style={
                windowButtonA
                  ? { width: "100%", backgroundSize: "60rem" }
                  : { width: "100%", backgroundSize: "100rem" }
              }
              tabIndex={show ? 0 : -1}
            >
              {windowButtonB.prompt}
            </button>
          )}
        </div>
      </aside>
      {/* <ReactTooltip
        id="tooltip-messageboxtool"
        effect="solid"
        delayShow={500}
      /> */}
    </div>
  );
}
